import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leagueEventStore } from 'state/league/leagueEvent'
import AddConstraintForm from './ModalContent/AddConstraintForm'

const AddConstraintModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addTeamConstraintModal, setAddTeamConstraintModal } = leagueEventStore(
    store => ({
      addTeamConstraintModal: store.addTeamConstraintModal,
      setAddTeamConstraintModal: store.setAddTeamConstraintModal,
    }),
  )

  const closeModal = () => {
    setAddTeamConstraintModal(false)
    form.resetFields()
  }

  return (
    <CustomModal
      openModal={addTeamConstraintModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Add constraints"
      width={560}
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save"
          btnType="primary"
          onSubmit={handleSubmit}
          closeModal={closeModal}
        />
      }
    >
      <AddConstraintForm form={form} />
    </CustomModal>
  )
}

export default AddConstraintModal
